import React from "react";
import ReactQuill from "react-quill";
import { useTranslation } from 'react-i18next';

import 'react-quill/dist/quill.snow.css';
import { toolPillMatcher } from './Config/quillToolPill';

export const getPlainTextLength = (html = '') => {
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return (tmp.textContent || tmp.innerText || '').replace(/\n$/, '').length;
};

const QuillComponent = ({
  name = '',
  theme = 'snow',
  value = '',
  onChange,
  placeholder = '',
  maxLength,
  overflowHidden = true,
  style = { height: 'calc(100vh - 300px)' },
  editorRef = null
}) => {
  const { t } = useTranslation('ChatbotIA');
  const currentLength = getPlainTextLength(value);
  const isOverLimit = Boolean(maxLength && currentLength > maxLength);

  return (
    <div className="tw-flex tw-flex-col tw-mt-4 tw-w-full">
      <div className="tw-flex tw-items-center tw-justify-between tw-mb-1">
        <span className="tw-font-regular tw-text-xs tw-text-blue-500">{t('config.text')}</span>
        {maxLength && (
          <span className={`tw-text-xs ${isOverLimit ? 'tw-text-red-500 tw-font-medium' : 'tw-text-gray-500'}`}>
            {currentLength}/{maxLength}
          </span>
        )}
      </div>
      <div
        className={`tw-w-full ${overflowHidden ? 'tw-overflow-hidden' : ''} [&_.ql-toolbar]:tw-rounded-t-lg [&_.ql-container]:tw-rounded-b-lg [&_.ql-container]:tw-border-t-0 [&_.ql-container]:tw-h-[calc(100%-42px)] [&_.ql-editor]:tw-h-full [&_.ql-editor]:tw-overflow-y-auto`}
        style={style}
      >
        <ReactQuill
          ref={editorRef}
          name={name}
          theme={theme}
          value={value || ''}
          onChange={onChange}
          placeholder={placeholder}
          style={{ height: '100%' }}
          modules={{
            toolbar: [
              [{ 'header': [1, 2, 3, 4, 5, false] }],
              ['bold', 'italic', 'underline'],
              [{ 'list': 'bullet' }, { 'list': 'ordered' }]
            ],
            clipboard: {
              matchers: [
                ['.mia-tool-pill', toolPillMatcher]
              ]
            }
          }}
        />
      </div>
    </div>
  );
};

export default QuillComponent;
